import api from 'API/index'

import {
  SET_ADMIN_INFO,
  SET_TOKEN_INFO
} from '../mutation-types'

import {
  saveAccessToken,
  getAccessToken,
  cachedAdminInfo,
  removeAccessToken,
  cachedKeysData
} from 'API/cacheService'

const state = {
  token: getAccessToken() || {},
  adminInfo: cachedAdminInfo.load() || cachedKeysData.adminInfo
}

const getters = {
  token (state) {
    return state.token
  },
  adminInfo (state) {
    return state.adminInfo
  }
}

const mutations = {
  [SET_TOKEN_INFO] (state, data) {
    state.token = data
  },
  [SET_ADMIN_INFO] (state, data) {
    state.adminInfo = data
  }
}

const actions = {
	/**
	 * 后台查看用户表单信息收集(分页)
	 */
	getUserFormList (store, params) {
	  return api.getUserFormList(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 后台查看表单样式管理(分页)
	 */
	getFormStyle (store, params) {
	  return api.getFormStyle(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 删除表单样式
	 */
	delFormStyle (store, params) {
	  return api.delFormStyle(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 添加表单样式
	 */
	addFormStyle (store, params) {
	  return api.addFormStyle(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 获取单个表单样式
	 */
	getFormStyleData (store, params) {
	  return api.getFormStyleData(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 修改单个表单样式
	 */
	upFormStyleData (store, params) {
	  return api.upFormStyleData(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 获取业务员数据（分页）
	 */
	getSalesman (store, params) {
	  return api.getSalesman(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 删除业务员数据
	 */
	delSalesman (store, params) {
	  return api.delSalesman(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 添加业务员数据
	 */
	addSalesman (store, params) {
	  return api.addSalesman(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 修改业务员数据
	 */
	upSalesmanData (store, params) {
	  return api.upSalesmanData(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 获取业务员数据
	 */
	getSalesmanData (store, params) {
	  return api.getSalesmanData(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 获取后台首页必要数据
	 */
	getHomeData (store, params) {
	  return api.getHomeData(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 链接生成页面数据获取
	 */
	getLinkData (store, params) {
	  return api.getLinkData(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 注销，退出系统
	 */
	exitlogin (store, params) {
	  return api.exitlogin(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},

}

export default {
  state,
  mutations,
  actions,
  getters
}


// WEBPACK FOOTER //
// ./src/store/modules/admin.js